module.exports = __webpack_public_path__ + "static/media/file.7a6fa342.svg";